export default __webpack_public_path__ + "static/eme-story1-4a3b356715969798cc3624d1b7b8fbdc.jpg";